/**
 * FEAT-108 / S-438 — the signed-in member's role in the active Clerk org, and
 * the capabilities `roles.ts` derives from it. While Clerk is still loading,
 * every capability reads false: a control appears a moment late rather than
 * flashing for a role that cannot use it.
 */
import { useOrganization } from "@clerk/clerk-react";
import { canDecide, canEdit, isAdminRole } from "./roles";

export function useRole() {
  const { membership, isLoaded } = useOrganization();
  const role = isLoaded ? (membership?.role ?? null) : null;
  return {
    role,
    /** False until Clerk has answered — don't redirect on a role not yet known. */
    isLoaded,
    canEdit: canEdit(role),
    canDecide: canDecide(role),
    isAdmin: isAdminRole(role),
  };
}
